import classNames from 'classnames';
import * as React from 'react';

import * as styles from './GeneralInfoSectionRow.css';

interface IGeneralInfoSectionRowProps {
  className?: string;
  children?: React.ReactNode;
  ref?: React.Ref<HTMLDivElement>;
}

export const GeneralInfoSectionRow = ({ children, className, ref }: IGeneralInfoSectionRowProps) => {
  return (
    <div ref={ref} className={classNames(styles['row'], className)} data-name="GeneralInfoSectionRowComponent">
      {children}
    </div>
  );
};
